<template>
    <transition-group name="fade">
        <div key="1" class="rounded-t-3xl hidden sm:block sm:rounded-none bg-leftPanelBG w-full h-20 sm:h-full fixed bottom-0 sm:top-0 pt-4 text-white sm:justify-items-left z-50 smooth-width-transition" 
            @mouseover="bigMenu = true" @mouseleave="bigMenu = false" :class="{'sm:w-48':bigMenu, 'sm:w-14':!bigMenu}" style="box-shadow: rgba(100, 100, 100, 0.25) 5px 0px 5px;">
            
            <div class="font-bold px-1 text-center" style="color:#10B981;font-size:28px;">X</div>

            <div v-if="menuItems">
                <div v-for="(item, index) in menuItems" :key="index" class="sm:w-full cursor-pointer px-4 text-lg leading-14 my-5 text-leftPanelText hover:text-white font-semibold">
                    <div class="whitespace-nowrap" @click="item.children && item.children.length > 0 ? toggleShowChildren(item.name) : false, item.click ? item.click : null">
                        <router-link v-if="item.link" :to="'../admin/' + item.link">
                            <font-awesome-icon :icon="item.icon" class="w-5"/>
                            <span class="pl-2" v-if="bigMenu">
                                {{ item.name }}
                                <font-awesome-icon v-if="item.children && item.children.length > 0" icon="fas fa-angle-down" class="mt-1.5 absolute right-3" />
                            </span>
                        </router-link>
                        <div v-else @click="callMethod(item.method)">
                            <font-awesome-icon :icon="item.icon" class="w-5"/>
                            <span class="pl-2" v-if="bigMenu">
                                {{ item.name }}
                                <font-awesome-icon v-if="item.children" icon="fas fa-angle-down" class="mt-1.5 absolute right-3" />
                            </span>
                        </div>
                    </div>
                    <span v-show="item.children && item.showChildren && bigMenu" class="text-tooltipText text-left sm:leading-8 whitespace-nowrap z-50">
                        <slot v-for="(child, chI) in item.children" :key="chI">
                            <router-link v-if="child?.link" :to="'../../' + child.link">
                            <div class="pl-8 block sm:w-full font-normal cursor-pointer hover:bg-gray-100 hover:text-leftPanelBG rounded">{{ child.name }}</div>
                            </router-link>
                        </slot>
                    </span>
                </div>
            </div>
            <div v-if="bigMenu" @click="toggleDarkMode" class="ml-4 my-2 sm:my-0 cursor-pointer pt-1 w-10 text-gray-700 text-center text-lg dark:text-dark.contentText rounded-full bg-gray-200 dark:bg-dark.panels ">
                <font-awesome-icon :icon="icon" />
            </div>
        </div>

        <div key="2" class="z-40 sm:hidden fixed bottom-0 left-0 bg-leftPanelBG text-white rounded-t-2xl w-full p-3 px-5">
            <font-awesome-icon @click="displayMenu = !displayMenu" icon="fas fa-bars" />
            <font-awesome-icon @click="logout()" icon="fas fa-arrow-right-from-bracket" class="absolute right-4 p-1" />
        </div>

    </transition-group>
</template>

<script>
    export default {
        data() {
            return {
                displayMenu: false,
                bigMenu: false,
                menuItems: [
                    {
                        name: "Permissions",
                        icon: "fas fa-gears",
                        showChildren: false,
                        link: "permissions",
                        children: []
                    },
                    {
                        name: "Companies",
                        icon: "far fa-building",
                        showChildren: false,
                        children: []
                    },
                ],
                mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light',
                icon: document.documentElement.classList.contains('dark') ? 'fa-solid fa-sun' : 'fa-solid fa-moon'
            }
        },
        methods: {
            toggleDarkMode() {
                this.mode = this.mode === 'light' ? 'dark' : 'light';
                this.icon = this.icon === 'fa-solid fa-moon' ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
                const html = document.documentElement; // Or document.body
                html.classList.toggle('dark');
                localStorage.setItem("darkMode", this.mode.toString() === 'dark');
            },
            callMethod(methodName) {
                if (methodName) {
                    if (typeof this[methodName] === 'function') {
                        this[methodName]();
                    }
                }
            },
        }
    }
</script>

<style scoped>
  .smooth-width-transition {
    transition: width 0.3s ease-in-out; /* Adjust time and easing function as needed */
  }
</style>